import React, { CSSProperties } from "react";
import { AddToCartModal } from "~/common/AddToCartModal";
import Modal, { Body, Footer, Header } from "~/common/ModalReact";

interface Props extends AddToCartModal<"commercialUse"> {
  onClose: () => void;
  onSubmit: (result: boolean) => void;
  type?: string;
}

const CommercialUseOnlyModal = ({
  isOpen,
  onClose,
  onSubmit,
  type = "warranty",
}: Props) => {
  const handleResidentialAddressClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    onSubmit(false);
  };

  const isCommercialModalForWarranty = type === "warranty";

  const handleCommercialAddressClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    onSubmit(true);
  };

  const iconStyle: CSSProperties = {
    fontSize: "26px",
    marginTop: "3px",
    color: "#f8a12f",
    marginRight: "8px",
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="modal--md"
      data-testid="commercial-use-modal"
    >
      <Header closeModal={onClose} className="items-start border-none p-6 pb-1">
        <i style={iconStyle} className="icon-attention" />
        <h3 className="modal-title mb-0">
          {isCommercialModalForWarranty
            ? "Commercial Use Only"
            : "Commercial Shipping Confirmation"}
        </h3>
      </Header>
      <Body className="mt-5">
        {isCommercialModalForWarranty && (
          <>
            <p className="text-sm leading-snug">
              <b>
                This product is only eligible for an extended warranty if used
                in a commercial setting.
              </b>{" "}
              Please verify that this product will be used solely in a
              commercial setting.
            </p>
            <p className="text-left text-xs text-gray-500 leading-tight">
              WebstaurantStore will not be responsible for any loss due to use
              of this product in a non-commercial setting.
            </p>
          </>
        )}
        {!isCommercialModalForWarranty && (
          <p className="text-sm leading-snug">
            We can only ship samples to commercial addresses. Is this product
            shipping to a commercial address?
          </p>
        )}
      </Body>
      <Footer className="modal-footer p-6">
        <div>
          <button
            data-testid="residential-use-btn"
            type="button"
            className="btn btn-light mr-4 mb-2"
            onClick={(e) => handleResidentialAddressClick(e)}
          >
            {`No, Residential ${isCommercialModalForWarranty ? "Use" : ""}`}
          </button>
          <button
            data-testid="commercial-use-btn"
            type="button"
            className="btn btn-primary mb-2"
            onClick={(e) => handleCommercialAddressClick(e)}
          >
            {`Yes, Commercial ${
              isCommercialModalForWarranty ? "Use Only" : "Address"
            } `}
          </button>
        </div>
      </Footer>
    </Modal>
  );
};

export default CommercialUseOnlyModal;
